import React from "react";
import "./Create.css";
import img from "../../assets/create.png";
import useLocation from "../../utils/Location";
import { getWhatsappLink } from "../../utils/getWhatsappNumber";
const Create = () => {
  const { countryCode } = useLocation();
  const whatsappLink = getWhatsappLink(countryCode);
  return (
    <div className="boxWrapper createboxwrapper">
      <div className="innerDiv createinnerDiv">
        <div className="leftCreate">
          <h1 className="headingCreate">Your Premium NFC Card, </h1>
          <h3 className="subheadingCreate">
            Delivered Safely Worldwide
          </h3>
          <p className="paraCreate">
            Fast, Secure & Reliable 
          </p>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button type="button" className="buttonCreate">
              Get yours today
            </button>
          </a>
        </div>
        <div className="rightCreate">
          <img src={img} alt="" className="imgcreate" />
        </div>
      </div>
    </div>
  );
};

export default Create;
